<template>
  <div>
    <v-card>
      <v-card-title class="header">
        <span class="headline">Manual Set Loan Amount</span>
      </v-card-title>
      <v-card-text class="content" style="margin-top: -10px">
        <v-row
          class="mb-12"
          justify="space-between"
        >
          <v-col class="text-center">
            <span class="subheading f-s-25 font-weight-light mr-1">$</span>
            <span
              class="display-2 font-weight-light"
              v-text="loanSizeRange.manualSetLoanSize"
            ></span>
          </v-col>
        </v-row>
        <v-slider
          v-model="loanSizeRange.manualSetLoanSize"
          :min="loanSizeRange.minimumLoanSize"
          :max="loanSizeRange.maximumLoanSize"
          color="orange darken-3"
          class="align-center touch-top"
          :step="loanSizeRange.step"
          always-dirty
          hide-details
        >
          <template v-slot:prepend>
            <v-icon
              @click="decrement"
            >
              mdi-minus
            </v-icon>
          </template>

          <template v-slot:append>
            <v-icon
              @click="increment"
            >
              mdi-plus
            </v-icon>
          </template>
        </v-slider>
      </v-card-text>
      <v-card-text class="content touch-top">
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <ValidationProvider name="Notes" rules="required" v-slot="{ errors }">
            <v-textarea
              v-model="notes"
              rows="3"
              label="Notes"
              hide-details="auto"
              :error-messages="errors[0]"
            ></v-textarea>
          </ValidationProvider>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions class="footer">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="hideDialog">Close</v-btn>
        <v-btn color="blue darken-1" text :loading="loading" @click="clickSaveHandler">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { OriginationBusinessApi, OriginationApi } from '@/api/pandaria'
import { Popup, DataType, Tool, Authentication } from '@/util/index'
const popup = new Popup()
const tool = new Tool()

export default {
  name: 'manual-set-loan-amount-dialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    loan: Object,
    dataSource: Object,
    manualSetLoanAmountMax: Number,
    authorization: Object
  },
  data () {
    return {
      assist: {
        dataType: DataType
      },
      notes: '',
      loading: false,
      loanSizeRange: {
        manualSetLoanSize: 200,
        minimumLoanSize: 200,
        maximumLoanSize: 5000,
        step: 50
      },
      roleCodeEnum: [
        DataType.RoleEnum.UNDERWRITER_AGENT.code,
        DataType.RoleEnum.UNDERWRITER_SUPERVISOR.code,
        DataType.RoleEnum.UNDERWRITER_MANAGER.code,
        DataType.RoleEnum.PRODUCTION_MANAGER.code,
        DataType.RoleEnum.PRODUCTION_MANAGER_ADMIN.code,
        DataType.RoleEnum.ADMINISTRATOR.code
      ],
      maxSize: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    loanAmount () {
      return this.dataSource.sectionData.loanAmount
    },
    roleCode () {
      return this.store.getters.getRoleCode
    }
  },
  watch: {
    loanId: {
      handler: async function () {
        const $this = this
        if (Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.SPECIAL_CONSIDERATION, this.assist.dataType.PrivilegeType.EXECUTABLE)) {
          if (this.loan.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value) {
            if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
              this.loanSizeRange.maximumLoanSize = 10000
              this.loanSizeRange.minimumLoanSize = 400
              this.loanSizeRange.step = 50
            } else {
              this.loanSizeRange.maximumLoanSize = 5000
              this.loanSizeRange.minimumLoanSize = 200
              this.loanSizeRange.step = 25
            }
          } else if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
            this.loanSizeRange.minimumLoanSize = 400
            this.loanSizeRange.maximumLoanSize = 3000
            this.loanSizeRange.step = 50
          } else if (this.loan.source === DataType.LoanSourceEnum.EXPRESS.value + DataType.LoanSourceEnum.VOIDED.value) {
            await OriginationApi.getExpressSourceLoan(this.loanId, function (result) {
              if (tool.isNotEmpty(result) && tool.isNotEmpty(result.loanAmount)) {
                $this.loanSizeRange.maximumLoanSize = result.loanAmount
                $this.maxSize = result.loanAmount
              } else {
                $this.loanSizeRange.minimumLoanSize = 200
                $this.loanSizeRange.maximumLoanSize = 250
                $this.loanSizeRange.step = 25
              }
            })
          } else if (this.roleCodeEnum.includes(this.roleCode) && this.loan.category === DataType.CategoryEnum.NEW_CUSTOMER.value) {
            this.loanSizeRange.minimumLoanSize = 200
            this.loanSizeRange.maximumLoanSize = 1500
            this.loanSizeRange.step = 25
          } else if (this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
            this.loanSizeRange.minimumLoanSize = 200
            this.loanSizeRange.maximumLoanSize = 1500
            this.loanSizeRange.step = 25
          } else {
            this.loanSizeRange.minimumLoanSize = 200
            this.loanSizeRange.maximumLoanSize = 250
            this.loanSizeRange.step = 25
          }
        } else {
          this.loanSizeRange.minimumLoanSize = 200
          this.loanSizeRange.maximumLoanSize = 250
          this.loanSizeRange.step = 25
        }
      },
      immediate: true
    },
    loanAmount: {
      handler: function (newVal) {
        this.loanSizeRange.manualSetLoanSize = newVal
      },
      immediate: true
    }
  },
  methods: {
    decrement () {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        this.loanSizeRange.manualSetLoanSize -= 50
      } else {
        this.loanSizeRange.manualSetLoanSize -= 25
      }
    },
    increment () {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        this.loanSizeRange.manualSetLoanSize += 50
      } else {
        this.loanSizeRange.manualSetLoanSize += 25
      }
    },
    hideDialog () {
      this.notes = ''
      this.$emit('hideDialog')
    },
    clickSaveHandler () {
      const $this = this
      this.$refs.observer.validate().then(noteResult => {
        if (noteResult) {
          $this.saveAction()
        }
      })
    },
    saveAction () {
      const $this = this
      $this.loading = true
      if (this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
        OriginationApi.getLoanSignData($this.loanId, function (result) {
          const signStatus = tool.isNotEmpty(result) ? result.signStatus : null
          if ((signStatus === DataType.SignStatusEnum.SIGNED.value) || signStatus === DataType.SignStatusEnum.NOT_SIGNED.value) {
            popup.popupForInfo('This change will effect the previous loan agreement. Are you sure continue?', {
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
            }, function () {
              $this.$emit('hideDialog')
              $this.manualSetLoanAmount()
            }, function () {
              $this.hideDialog()
              $this.loading = false
            })
          } else {
            $this.manualSetLoanAmount()
            $this.$emit('hideDialog')
          }
        }, function (result) {
          $this.loading = false
          popup.popupForWarning(result.message)
          $this.hideDialog()
        })
      }
    },
    manualSetLoanAmount () {
      const $this = this
      const requestData = {
        loanId: this.loanId,
        loanAmount: this.loanSizeRange.manualSetLoanSize,
        notes: this.notes,
        isManual: true
      }
      OriginationBusinessApi.specialLoanAmount(requestData, function (result) {
        $this.notes = ''
        $this.$eventBus.$emit('loanIntegratedComputationResult', result)
        $this.loading = false
        if ($this.loan.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value) {
          if ($this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
            $this.loanSizeRange.maximumLoanSize = 10000
          } else {
            $this.loanSizeRange.maximumLoanSize = 5000
          }
        } else if ($this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
          $this.loanSizeRange.maximumLoanSize = 3000
        } else if ($this.loan.source === DataType.LoanSourceEnum.EXPRESS.value + DataType.LoanSourceEnum.VOIDED.value) {
          $this.loanSizeRange.maximumLoanSize = tool.isNotEmpty($this.maxSize) ? $this.maxSize : 250
        } else if ($this.roleCodeEnum.includes($this.roleCode) && $this.loan.category === DataType.CategoryEnum.NEW_CUSTOMER.value) {
          $this.loanSizeRange.maximumLoanSize = 1500
        } else {
          $this.loanSizeRange.maximumLoanSize = 250
        }
      }, function (result) {
        popup.popupForWarning(result.message)
        $this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .header {
    position: relative;
    z-index: 999;
    top: 0;
    background-color: white;
  }
  .content {
    margin-top: 30px;
  }
  .footer {
    position: relative;
    z-index: 999;
    bottom: 0;
    background-color: white;
  }
  .touch-top {
    margin-top: -20px;
  }
</style>
